import * as types from './constants'

const initialState = {
    loading: true,
    mainImage: null,
    changedImage: null,
    isSaving: false,
    savingError: null,
    error: null,
}

const reducer = (state = initialState, actions) => {
    switch (actions.type) {
        case types.INITIAL_DATA:
            return {
                ...state,
                mainImage: actions.image,
                loading: actions.loading,
            }
        case types.SAVE_DATA_STARTED:
            return {
                ...state,
                isSaving: true,
                savingError: null,
            }
        case types.SAVE_DATA_SUCCESS:
            return {
                ...state,
                isSaving: false,
                savingError: null,
            }
        case types.SAVE_DATA_FAILED:
            return {
                ...state,
                savingError: actions.error,
                isSaving: false,
            }

        default:
            return state
    }
}

export default reducer
